module.exports = __webpack_public_path__ + "static/media/pod-unassigned.9824fdeb.svg";